import { type Accessor, type ParentComponent, createContext } from "solid-js";
import { createStore } from "solid-js/store";
import AudioPlayer from "./components/AudioPlayer";
import type { PlayerStore } from "./types";

const [player, setPlayer] = createStore<PlayerStore>({
	playing: false,
	time: 0,
	queue: [],
	loading: false,
	feed: { type: "HOME", page: 1 },
	track: -1,
	disabled: true,
	resume: true,
});

export const playerContext = createContext<{
	player: typeof player;
	setPlayer: typeof setPlayer;
	handleTogglePlayer: (resume?: boolean) => void;
	canGoNext: Accessor<boolean>;
	canGoPrevious: Accessor<boolean>;
	handleSetProgress: (progress: number) => void;
}>({
	player,
	setPlayer,
	handleTogglePlayer: () => {},
	canGoNext: () => false,
	canGoPrevious: () => false,
	handleSetProgress: () => {},
});

export const PlayerProvider: ParentComponent = (props) => {
	return (
		<AudioPlayer>
			{(handleTogglePlayer, canGoNext, canGoPrevious, handleSetProgress) => (
				<playerContext.Provider
					value={{ player, setPlayer, handleTogglePlayer, canGoNext, canGoPrevious, handleSetProgress }}
				>
					{props.children}
				</playerContext.Provider>
			)}
		</AudioPlayer>
	);
};
